import { useEffect, useState } from "react";
import { useStore } from "../webar-core/framework/store/Store";
import cn from "../languages/cn";
import "../styles/componentStyles/AgeGateComponent.scss";
import { AudioAsset } from "../webar-core/framework/store/AssetSlice";
/**
 * This Component shows an age gate that dictates whether or not should the user proceed with the experience
 * @param props
 * @returns
 */
export const AgeGateComponent = (props: any) => {
  const [modalAnimateIn, setModalAnimateIn] = useState(false);
  const [modalAnimateOut, setModalAnimateOut] = useState(false);
  const [enterButtonClicked, setEnterButtonClicked] = useState(false);

  useEffect(() => {
    setModalAnimateIn(true);
  }, []);

  return (
    <>
      <div
        id="ageGateContainer"
        className={`${props.ageGateAllowed ? "hidden" : ""}`}
      >
        <div
          id="ageGatePopUp"
          className={`${modalAnimateIn ? "animateIn" : ""} ${
            modalAnimateOut ? "animateOut" : ""
          }`}
        >
          <div id="ageGatePopUpText">
            {props.translate
              ? cn.ageGatePopUpText.text
              : "Are you over the legal" +
                "\n" +
                "minimum drinking age in" +
                "\n" +
                "your country?"}
          </div>
          <div className="buttonsWrapper">
            <button id="ageButtonNo">
              <span id="ageGateSpanNo">
                {props.translate ? cn.ageGateSpanNo.text : "No"}
              </span>
            </button>
            <button
              id="ageButtonYes"
              className={`allow ${enterButtonClicked ? "active" : ""}`}
              onClick={() => {
                setEnterButtonClicked(true);
                (
                  useStore
                    .getState()
                    .assets.get("ageGateYesSoundEffect") as AudioAsset
                ).play();
                (
                  useStore
                    .getState()
                    .assets.get("backgroundMusic") as AudioAsset
                ).play();
                setTimeout(() => {
                  setModalAnimateOut(true);
                  setTimeout(() => {
                    props.setAgeGateAllowed(true);
                  }, 500);
                }, 500);
              }}
            >
              <img
                className="highlight"
                src="https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/ui/loadingPage/gradientSwipe.png"
                alt=""
              />
              <span id="ageGateSpanYes">
                {props.translate ? cn.ageGateSpanYes.text : "Yes"}
              </span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
